import React from "react";

import styles from "./DoctorNameSelector.style";
import {Panel, PanelHeader, PanelHeaderBack, SimpleCell, Text} from "@vkontakte/vkui";
import {connect} from "react-redux";
import { setActivePanel, setPreviousPanel } from "../../redux/actions/panelsActions";
import {panels} from "../../variables";
import Icon24Done from "@vkontakte/icons/dist/24/done";
import {selectDoctorName} from "../../redux/actions/doctorsActions";

const DoctorNameSelector = ({
                                id, goBack,
                                selectDoctorName, goToDatePanel,
                                doctorNames, selectedDoctorName
                            }) => {

    const mapNameToSimpleCell = (doctorName) => {
        return (
            <SimpleCell
                key={getDoctorName(doctorName)}
                onClick={() => {
                    selectDoctorName(doctorName);
                    goToDatePanel();
                }}
                after={
                    selectedDoctorName && areDoctorNamesEqual(selectedDoctorName, doctorName)
                        ? <Icon24Done fill="var(--accent)"/>
                        : null
                }
            >
                {getDoctorName(doctorName)}
            </SimpleCell>
        )
    }

    const areDoctorNamesEqual = (first, second) => {
        return getDoctorName(first) === getDoctorName(second)
    }

    const getDoctorName = (doctor) => {
        return doctor.attributes[1].value
    }

    return (
        <Panel id={id}>
            <PanelHeader
                left={<PanelHeaderBack onClick={() => goBack()}/>}>
                <span style={styles.blue}>ГОС</span><span style={styles.red}>УСЛУГИ</span>
            </PanelHeader>
            {
                doctorNames.length
                    ? doctorNames.map(mapNameToSimpleCell)
                    : <>
                        <Text weight="regular" style={styles.red}>К сожалению</Text>
                        <Text weight="regular" style={styles.red}>Нет доступных врачей</Text>
                    </>
            }
        </Panel>
    )
}

const mapStateToProps = (state) => {
    return {
        doctorNames: state.doctors.doctorNames,
        selectedDoctorName: state.doctors.selectedDoctorName,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        goBack: () => dispatch(setPreviousPanel()),
        selectDoctorName: (doctorName) => dispatch(selectDoctorName(doctorName)),
        goToDatePanel: () => dispatch(setActivePanel(panels.choseDate))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DoctorNameSelector);
